import { createContext, type PropsWithChildren, useContext } from 'react';
import { ModuleFormSource } from '../../module/form/ModuleFormSource.ts';

/**
 * Context con l'ambiente del riepilogo (`FRONTOFFICE` o `BACKOFFICE`).
 */
export const SummarySourceContext = createContext<ModuleFormSource>(
  ModuleFormSource.FRONTOFFICE,
);

export const useSummarySource = () => useContext(SummarySourceContext);

/**
 * Dichiara l'ambiente del riepilogo ai componenti condivisi. Il Frontoffice
 * non monta il provider: è il valore di default.
 */
export function SummarySourceProvider(
  props: PropsWithChildren<{ source: ModuleFormSource }>,
) {
  const { source, children } = props;
  return (
    <SummarySourceContext.Provider value={source}>
      {children}
    </SummarySourceContext.Provider>
  );
}
